import { fetchFavorites } from "@/services/favorites";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export const useFavoritesQuery = (
  options?: Omit<UseQueryOptions<Awaited<ReturnType<typeof fetchFavorites>>, unknown>, "queryKey">
) => {
  return useQuery<Awaited<ReturnType<typeof fetchFavorites>>, unknown>(
    {
      queryKey: ["favorites"],
      queryFn: fetchFavorites,
      retry: (failureCount, error: any) => {
        if (error?.response?.status === 401) return false;
        return failureCount < 1;
      },
      ...(options ?? {}),
    }
  );
};